const faq = [
    {
        id: 0,
        q: 'What is it?',
        a: 'Hall of Fame is a place where each user visiting my website can leave one unique message. Leaving a message is only possible after solving the puzzle. After solving the puzzle, your answer will be saved in local storage (you don\'t need to solve it again).'
    },
    {
        id: 1,
        q: 'What does it mean unique?',
        a: 'The message is unique for the given username (after sending the message, the username is taken and cannot be used again).'
    },
    {
        id: 2,
        q: 'Are messages editable or deletable?',
        a: 'No, messages are not editable nor deletable.'
    },
    {
        id: 3,
        q: 'What tools were used to create this page?',
        a: 'This page was created using the React framework and JavaScript, HTML and CSS languages. Hall of Fame Console was created using HTML and CSS only.'
    },
    {
        id: 4,
        q: 'What do the console statuses mean?',
        a: 'The console status informs the user about the successful or negative course of the actions performed. Full list of statuses: \n\nSTATUSES_LIST'
    }
];

export default faq;
